import React from 'react'
import SEO from '../components/seo/SEO';
import { getWebPageSchema } from '../components/seo/StructuredData';
import Navbar from '../components/common/Navbar'
import Getintouch from '../components/layout/GetInTouch'
import Footer from '../components/common/Footer'
import About1 from '../components/ui/About1'

function About_us() {
  const structuredData = getWebPageSchema(
    "About Us - Algoarts",
    "In 5 years, Algoarts has grown into a world-class product development and software services company. Learn about our journey, values, and commitment to turning ideas into digital reality.",
    "https://algoarts.tech/about_us"
  );
  
  return (
        <>
            <SEO
                title="About Us"
                description="In 5 years, Algoarts has grown into a world-class product development and software services company. Learn about our journey, values, and commitment to turning ideas into digital reality."
                keywords="about Algoarts, company history, software company Sri Lanka, Algoarts team, company values, software services company"
                url="https://algoarts.tech/about_us"
                structuredData={structuredData}
            />
            <Navbar />
            <div className="pt-18 pb-38 h-screen flex flex-col justify-center items-center bg-[#0f072c]">
                <div className="absolute inset-0 bg-gradient-to-r from-purple-400 via-pink-500 to-purple-400 opacity-20 blur-2xl rounded-full w-[200px] h-[200px] md:w-[500px] md:h-[500px] mx-auto">

                </div>
                <div
                    className="relative text-center"
                    data-aos="fade-up" // Animation type
                    data-aos-duration="1000" // Duration of the animation
                    data-aos-once="true" // Ensures animation occurs only once
                >
                    <p className="pb-8 text-sm font-bold font-lexend tracking-tight text-pink-500 sm:text-2xl">
                        since 2022                    
                        </p>
                    <span className="text-3xl sm:text-6xl font-lucida font-bold text-white ">
                       Little bit about
                        <br></br> <span className='bg-gradient-to-r from-purple-400 to-pink-500 text-transparent bg-clip-text hover:bg-gradient-to-r hover:from-pink-500 hover:to-yellow-500 transition-all duration-500'>
                            our journey
                        </span>
                    </span>
                    <p className="mt-8 text-lg sm:text-xl text-white max-w-sm sm:max-w-3xl mx-auto">
                        Story Of Algoarts
                    </p>
                </div>
            </div>
            <About1/>
            <Getintouch />
            <Footer />
        </>
    )
}

export default About_us